<template>
  <DataTable
    class="tableHeaderStyle"
    :value="priceLog"
    stripedRows
    tableStyle="min-width: 50rem"
    ref="dt"
    :exportFilename="exportFileName"
  >
    <!-- <Column sortable field="index" header="#" /> -->

    <Column sortable field="dateAdded" header="Date created">
      <template #body="log">
        {{ formatDate(log.data.dateAdded) }}
      </template>
    </Column>

    <Column sortable field="productId" header="Product">
      <template #body="log">
        <ProductType :type="log.data.productName" />
      </template>
    </Column>

    <Column sortable field="startDate" header="Start Date">
      <template #body="log">
        {{ formatDate(log.data.startDate) }}
      </template>
    </Column>
    <Column sortable field="endDate" header="End Date">
      <template #body="log">
        {{ formatDate(log.data.endDate) }}
      </template>
    </Column>

    <Column sortable field="price" header="Price">
      <template #body="log">
        {{ amountFormat(log.data.price) }}
      </template>
    </Column>
    <Column sortable field="action" header="Action">
      <template #body="log">
        <button
          class="bg-[var(--green100)] px-4 py-2 text-white w-full rounded-md"
          @click="showDrawer(log.data)"
        >
          View Exemptions
        </button>
      </template>
    </Column>

    <!-- <Column header="Status">
      <template #body="log">
        <PaymentStatusType :type="log.data.priceControlStatus?.toLowerCase()" />
      </template>
    </Column> -->

    <!-- <Column header="Action">
      <template #body="log">
        <PaymentStatusType :type="log.data.priceControlStatus?.toLowerCase()" />
      </template>
    </Column> -->

    <template #empty>
      <div class="pt-4 text-center">
        <EmptyList :type="'Price change log'" />
      </div>
    </template>
  </DataTable>

  <Pagination :paginationData="pagination" :handler="handlePagination" />
  <PriceChangeLogExemption
    :open="open"
    :close="close"
    :data="data"
    :getPriceChangeLog="getPriceChangeLog"
  />
</template>

<script>
//utils
import { amountFormat, formatNumber, formatDate } from "@/utils/formatter";
import PriceChangeLogExemption from "@/components/pages/Depot/Drawers/PriceLogExemptions";
//libraries
import Column from "primevue/column";
import DataTable from "primevue/datatable";

//components

import ProductType from "@/components/UI/ProductTypes";
import Pagination from "@/components/UI/Pagination/index.vue";
import Button from "@/components/UI/Buttons/DrawerButton.vue";
import PaymentStatusType from "@/components/UI/PaymentStatusTypes";
import EmptyList from "@/components/Empty/index.vue";

export default {
  name: "DepotPriceChangeLog",
  props: [
    "details",
    "priceLog",
    "exportFileName",
    "pagination",
    "handlePagination",
    "getPriceChangeLog",
  ],
  components: {
    Column,
    DataTable,
    PriceChangeLogExemption,
    Button,
    Pagination,
    ProductType,
    PaymentStatusType,
    EmptyList,
  },
  data() {
    return {
      formatDate,
      open: false,
      amountFormat,
      data: "",
      formatNumber,
    };
  },
  mounted() {},
  methods: {
    exportTable() {
      this.$refs.dt.exportCSV();
    },
    showDrawer(log) {
      this.open = true;
      this.data = log;
    },
    close() {
      this.open = false;
    },
  },
};
</script>

<style></style>
